import Model from "@/app/models/Concerns/Model";
import PaginatedResponse from "@/app/models/Concerns/PaginatedResponse";
import Project from "@/app/models/Project";
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";

export default class ProductionOrder extends Model {
    project_id!: number;
    isah_id!: string;
    isah_order_number!: string;
    name!: string;
    is_finished!: boolean;
    signed_checklists_count?: number;
    brands_count?: number;

    private _project!: Project;

    get project(): Project | any {
        return this._project;
    }

    set project(project: Project | any) {
        this._project = new Project(project);
    }

    public static async show(id: number): Promise<Model> {
        const constructor = this as Function;
        const response: AxiosResponse<{ data: Model }> = await Client.get([this.table, id, 'show'].join('/'));

        // @ts-ignore
        return new constructor(response.data.data);
    }

    public static async current(): Promise<ProductionOrder> {
        const constructor = this as Function;
        const response: AxiosResponse<{ data: ProductionOrder }> = await Client.get([this.table, 'current'].join('/'));

        // @ts-ignore
        return new constructor(response.data.data);
    }

    public static async open(page: number = 1, params: { [key: string]: any } = {}): Promise<PaginatedResponse<Model>> {
        return await this.index(page, params, this.table + '/open');
    }
    
    getTable(): string {
        return "production-orders";
    }
}
